import { GlobalAlert } from '@thoughtspot/global-alert';
import { useTranslation } from '@thoughtspot/i18n';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { TOAST_HIDE_DELAY_MS } from '@thoughtspot/radiant-react/widgets/alert/alert-constants';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useCallback, useEffect, useMemo, useState, } from 'react';
import { IntegrationActionEnum } from "../../../services/generated/graphql-types";
import { useGetIntegrationsListQuery } from "../../../services/spotiq/spotiq-service";
import { Vertical } from "../../../utils/layouts";
import { SettingsWrapper } from '../settings-wrapper/settings-wrapper.container';
import { IntegrationActionModalContainer } from './add-edit-integration-modal/integration-action-modal.container';
import { IntegrationList } from './integration-list/integration-list';
import styles from './integration-list/integration-list.module.scss';
import { retryButton, transformToTableViewRows, TranslationsKeys, } from './util';
export const MLIntegrationsContainerAdmin = () => {
    const { t } = useTranslation();
    const [isModalOpened, setIsModalOpened] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [bannerMessage, setBannerMessage] = useState('');
    const [integrationAction, setIntegrationAction] = useState(IntegrationActionEnum.Create);
    const { data: integrationsListData, loading: integrationsListLoading, error: integrationsListError, refetch: integrationsListRefetch, } = useGetIntegrationsListQuery();
    const listRowData = useMemo(() => {
        return transformToTableViewRows(integrationsListData?.Data);
    }, [integrationsListData]);
    const [currRowId, setCurrRowId] = useState(null);
    const onClickAddIntegrationBtn = () => {
        setIsModalOpened(true);
        setCurrRowId(null);
        setIntegrationAction(IntegrationActionEnum.Create);
    };
    const onEdit = useCallback((row) => {
        setCurrRowId(row.id);
        setIsModalOpened(true);
        setIntegrationAction(IntegrationActionEnum.Edit);
    }, []);
    const onDelete = useCallback((row) => {
        setCurrRowId(row.id);
        setIsModalOpened(true);
        setIntegrationAction(IntegrationActionEnum.Delete);
    }, []);
    const onCloseToast = useCallback(() => {
        setToastMessage('');
    }, []);
    const onCloseBanner = useCallback(() => {
        setBannerMessage('');
    }, []);
    const alertBanner = integrationsListError && (React.createElement(Alert.Banner, { message: t(TranslationsKeys.ERROR_INTEGRATION_LIST), isVisible: true, type: BannerAlertType.ERROR, primaryAction: retryButton(integrationsListRefetch), showCloseButton: false }));
    const emptyListMessage = !integrationsListError &&
        listRowData?.length === 0 && (React.createElement(Typography, { variant: "content-label-subhead", className: styles.emptyList, "data-testid": "empty-list" }, t(TranslationsKeys.EMPTY_INTEGRATION_LIST)));
    const integrationListComponent = !integrationsListError &&
        listRowData?.length > 0 && (React.createElement(IntegrationList, { integrationsList: listRowData, integrationsListLoading: integrationsListLoading, onEdit: onEdit, onDelete: onDelete }));
    const integrationListLoadingComponent = integrationsListLoading && (React.createElement(IntegrationList, { integrationsList: listRowData, integrationsListLoading: integrationsListLoading, onEdit: onEdit, onDelete: onDelete }));
    useEffect(() => {
        let timer;
        if (toastMessage) {
            timer = setTimeout(() => {
                setToastMessage('');
            }, TOAST_HIDE_DELAY_MS);
        }
        return () => clearTimeout(timer);
    }, [toastMessage]);
    return (React.createElement(SettingsWrapper, { id: "admin-ml-integrations-container", title: t(TranslationsKeys.TITLE), error: "errorConfig", renderActionButton: () => (React.createElement(Button, { icon: IconID.PLUS, text: t(TranslationsKeys.ADD_INTEGRATION_BTN), onClick: onClickAddIntegrationBtn, type: "secondary", "data-testid": "add-integration-btn" })), description: t(TranslationsKeys.DESCRIPTION) },
        React.createElement(Vertical, null,
            React.createElement(React.Fragment, null,
                alertBanner,
                integrationListLoadingComponent,
                emptyListMessage,
                integrationListComponent),
            isModalOpened && (React.createElement(IntegrationActionModalContainer, { currRow: currRowId
                    ? listRowData.find(_ => _.id === currRowId)
                    : null, setCurrRowId: setCurrRowId, integrationsListRefetch: integrationsListRefetch, actionModalType: integrationAction, setIsActionModalOpen: setIsModalOpened, isActionModalOpen: isModalOpened, setSuccessToast: setToastMessage, setFailureMessage: setBannerMessage })),
            React.createElement(GlobalAlert.Toast, { message: toastMessage, isVisible: !!toastMessage, autoHide: false, onClose: onCloseToast }),
            React.createElement(GlobalAlert.Banner, { message: bannerMessage, isVisible: !!bannerMessage, onClose: onCloseBanner, type: BannerAlertType.ERROR }))));
};
//# sourceMappingURL=mlIntegration.container.js.map